module.exports = __webpack_public_path__ + "img/toListEnd.f754a4b5.svg";